'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$4() {
  this.aJ7 = null;
  this.aJ5 = null;
  this.aJ6 = false;
  this.aJ3 = null;
  this.aJ4 = false;
  this.aJ8 = false;
  this.aJ9 = false;
  this.aJ7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DangerAlert$$anon$4 as $c_Lpresto_DangerAlert$$anon$4 };
$p = $c_Lpresto_DangerAlert$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$4;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$4() {
}
export { $h_Lpresto_DangerAlert$$anon$4 as $h_Lpresto_DangerAlert$$anon$4 };
$h_Lpresto_DangerAlert$$anon$4.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aJ7;
});
$p.t = (function() {
  if ((!this.aJ6)) {
    this.aJ5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aJ6 = true;
  }
  return this.aJ5;
});
$p.ag = (function() {
  if ((!this.aJ4)) {
    this.aJ3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().ph(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().a35(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aJ4 = true;
  }
  return this.aJ3;
});
$p.v = (function() {
  if ((!this.aJ9)) {
    this.aJ8 = false;
    this.aJ9 = true;
  }
  return this.aJ8;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_DangerAlert$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$4, "presto.DangerAlert$$anon$4", ({
  Gr: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DangerAlert$$anon$4 as $d_Lpresto_DangerAlert$$anon$4 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$4.js.map
